import clerk from '@/lib/clerk';
import sharedMessages from '@/lib/shared-messages';

export type ErrorMessage = {
  type: 'error' | 'warning';
  message: string;
};

export const getClerkStatus = async (): Promise<ErrorMessage> => {
  if (clerk.session && clerk.session.status === 'active') {
    return {
      type: 'error',
      message: 'Already logged in',
    };
  }
  const signIn = clerk.client?.signIn;
  if (!signIn) {
    return {
      type: 'error',
      message: sharedMessages.invalidClerkAccountStatus,
    };
  }

  return {
    type: 'error',
    message: sharedMessages.invalidClerkAccountStatus,
  };
};
